"use client";
import { SetStateAction, useState } from "react";

import _ from "lodash";
import './home.css';

import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography
} from "@mui/material";

import DocumentMeta from "react-document-meta";
import FooterComponent from "../../components/footer";
import { TypeAnimation } from 'react-type-animation';
import Header from "../../components/header/header";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import YoutubeEmbed from "../../components/youtube-embed/youtube-embed";
import { Link } from "react-router-dom";
import TopBanner from "../../components/top-banner/top-banner";

export default function Home(): JSX.Element {
  const [message, setMessage] = useState("");
  const [showTypeAnimation, setShowTypeAnimation] = useState(true);
  const [disclamerChecked, setDisclamerChecked] = useState(false);
  const [checkboxClass, setCheckboxClass] = useState("")

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);
  };

  const meta = {
    title: "123Skincare - Suggest the best skincare products, with AI",
    description:
      "123Skincare uses AI to find the perfect skincare products for you. We provide personalized skincare recommendations. We cover the best niche products as well as big brands.",
    canonical: "https://www.123skincare.pro/",
  };

  const saveQuery = async (userQuery: string) => {
    const apiUrl = 'https://d38anxdizfypxi.cloudfront.net/default/storeUserQuery';
    const headers = {
      "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ query: userQuery }),
    });
  }

  const updateShowTypeAnimation = (flag: boolean) => {
    if (flag) {
      if (message !== "") {
        setShowTypeAnimation(false);
      } else {
        setShowTypeAnimation(true);
      }
    }
  }

  const next = (question: string) => {
    if (disclamerChecked) {
      const currentDate = new Date();
      const quizId = currentDate.valueOf().toString();
      window.location.href = "/solutions?q=" + encodeURI(question) + "&quizId=" + quizId;
    } else {
      setCheckboxClass("error")
    }
  }

  const handleDisclamerCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisclamerChecked(event.target.checked);
  };

  return (
    <DocumentMeta {...meta}>
      <TopBanner />
      <Header showLogo={false} />
      <Box className="main"
        sx={{
        width: "100%",
        margin: "0 auto",
        padding: 0,
        }}>

        <div className="container">
          <div className="wrapper">
      
      <Box className="site-logo">
        <Link to="/">
                <img
                  alt=""
                  src="/assets/site-logo.png"
                  height="70px"
                  style={{ objectFit: "cover" }}
                />
        </Link>
      </Box>

      <Box className="search-title">
        <Typography
                  variant={"h4"}
                  textAlign={"left"}
                  sx={{
                    display: { xs: "flex", sm: "none" },
                  }}
                >
                  Skincare products that fit your query
        </Typography>
        <Typography className="summary"
                  variant={"h3"}
                  sx={{
                    display: { xs: "none", sm: "flex" },
                  }}
                >
                  Skincare products that fit your query
        </Typography>
      </Box>

      <div className="images">
        <div className="image-container"
          onClick={() => { next('Anti-acne Skincare?') }}>
          <img src="/assets/anti-acne.jpg"/>
          <div className="text">
            <div className="text-wrapper">
              <span className="image-title">Anti-acne Skincare</span>
              <span className="image-subtitle">Click to see more</span>
            </div>
          </div>
        </div>
        <div className="image-container image-2"
          onClick={() => { next('The best sunscreen?') }}>
          <img src="/assets/best-sunscreen.png"/>
          <div className="text">
            <div className="text-wrapper">
              <span className="image-title">The best sunscreen</span>
              <span className="image-subtitle">Click to see more</span>
            </div>
          </div>
        </div>
        <div className="image-container"
          onClick={() => { next('Anti-aging Skincare?') }}>
          <img src="/assets/anti-aging.png"/>
          <div className="text">
            <div className="text-wrapper">
              <span className="image-title">Anti-aging Skincare</span>
              <span className="image-subtitle">Click to see more</span>
            </div>
          </div>
        </div>
      </div>

      {/* top */}
      <Box id="search-box" className="top-content"
        sx={{
          background: "white",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "0 0 48px 0",
        }}
      >

        <Box className="search-action"
          sx={{
            padding: "0 20px",
            width: "100%",
            display: { xs: "block", sm: "flex" },
            flexDirection: { xs: "row", md: "row" },
            position: "relative"
          }}
        >
          <div className="search-box">
            {/*<input
              id="input-with-sx"
              onFocus={(ev) => setShowTypeAnimation(false)}
              onBlur={(ev) => setShowTypeAnimation(true)}
              onChange={handleChange}
              onKeyDown={(ev) => {
                console.log(`Pressed keyCode ${ev.key}`);
                if (ev.key === "Enter") {
                  // Do code here
                  ev.preventDefault();
                  fetch("https://www.nyckel.com/connect/token", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: "client_id=womjlujzg6ly9p50tzqplyblvwpdkw20&client_secret=14akjsniydb2rzduiy6enkpxd1op46ej4kx5fkg0c7q8m8tvjvulqocgfc7h3xds&grant_type=client_credentials",
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      try {
                        fetch(
                          "https://www.nyckel.com/v0.9/functions/uqr5ngdavefvkx6l/invoke",
                          {
                            method: "POST",
                            headers: {
                              Authorization: "Bearer " + data.access_token,
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ data: message }),
                          }
                        )
                          .then((response) => response.json())
                          .then((data) => {
                            const tag = _.head(data);
                            const tagLabel = _.get(tag, "labelName");
                            console.log(
                              `/questions?q=${encodeURI(message)}${
                                tagLabel ? `&tag=${tagLabel}` : ""
                              }`
                            );
                            window.location.replace(
                              `/questions?q=${encodeURI(message)}${
                                tagLabel ? `&tag=${tagLabel}` : ""
                              }`
                            );
                          });
                      } catch (e) {
                        window.location.replace(
                          "/questions?q=" + encodeURI(message)
                        );
                      }
                    });
                }
              }}
              value={message}
            />*/}
            <input
              id="input-with-sx"
              onFocus={(ev) => setShowTypeAnimation(false)}
              onBlur={(ev) => updateShowTypeAnimation(true)}
              onChange={handleChange}
              onKeyDown={(ev) => {
                console.log(`Pressed keyCode ${ev.key}`);
                if (ev.key === "Enter") {
                  // Do code here
                  ev.preventDefault();
                  if (message && _.trim(message) !== "") {
                    next(message);
                  }
                }
              }}
              value={message}
            />
            {showTypeAnimation ? 
            (<TypeAnimation className="type-animation"
              sequence={[
                'How do I get rid of acne?',
                2000, 
                'Best Face Washes for all skin type?', 
                2000, 
                'How do I apply retinol?',
                2000
              ]}
              wrapper="span"
              cursor={true}
              repeat={Infinity}
              style={{ position: "absolute" }}
            />) : '' }

            <ArrowForwardIcon className="search-icon"
              onClick={() => {
                if (message && _.trim(message) !== "") {
                  next(message);
                }
              }}
            />
          </div>

          {/*<Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              width: { xs: "60%", sm: "30%" },
              position: "relative",
              left: { xs: "0px", sm: "-5px" },
              margin: { xs: "0 auto", sm: "0" },
            }}
          >
            <Button className="btn-ask-me"
              variant="contained"
              fullWidth
              sx={{
                color: "white !important",
                background: "#ff6b73 !important",
                height: "100%",
                marginTop: { xs: "20px", sm: "0" },
              }}
              onClick={() => {
                saveQuery(message).then(() => window.location.href = "/questions?q=" + encodeURI(message));
              }}
              disabled={!message || _.trim(message) === ""}
            >
              Ask me!
            </Button>
          </Box>*/}
        </Box>

        <Box className="subtitles"
          sx={{
            padding: "0 20px",
            width: "100%",
            display: { xs: "none", md: "flex" },
            flexDirection: { xs: "row", md: "row" },
            position: "relative"
          }}
        >
          <Typography
            variant={"subtitle2"}
            style={{
              marginRight: "15px",
            }}
          >
            {" "}
            <img
              alt=""
              src="/assets/icon-tick.svg"
              width="24px"
              style={{
                objectFit: "cover",
                display: "inline",
                marginRight: "5px",
                verticalAlign: "text-bottom",
              }}
            />
            All Skintype
          </Typography>
          <Typography
            variant={"subtitle2"}
            style={{
              marginRight: "15px",
            }}
          >
            {" "}
            <img
              alt=""
              src="/assets/icon-tick.svg"
              width="24px"
              style={{
                objectFit: "cover",
                display: "inline",
                marginRight: "5px",
                verticalAlign: "text-bottom",
              }}
            />
            All Age range
          </Typography>
          <Typography
            variant={"subtitle2"}
            style={{
              marginRight: "15px",
            }}
          >
            {" "}
            <img
              alt=""
              src="/assets/icon-tick.svg"
              width="24px"
              style={{
                objectFit: "cover",
                display: "inline",
                marginRight: "5px",
                verticalAlign: "text-bottom",
              }}
            />
            Unbiased suggestions
          </Typography>
        </Box>

        <Box className="disclamer">
          <FormControlLabel className={`checkbox-field ${ checkboxClass }`}
            control={<Checkbox checked={disclamerChecked} onChange={handleDisclamerCheckboxChange} />} 
            label="By submitting your query, you consent to the collection and processing of your personal data by our AI system in order to provide personalized suggestions and product recommendations." />
        </Box>

        <Box className="benefits"
          sx={{
            width: "100%",
            display: { sm: "flex" },
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
          }}
        >
          <Box className="away-title"
            sx={{
              padding: "10px 20px",
              fontSize: "20px",
            }}
          >
            We are supported by
          </Box>

          <Box className="away-point"
            sx={{
              padding: "10px",
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <img
              alt=""
              src="/assets/logo-kised.jpg"
              height="75px"
              style={{ objectFit: "cover" }}
            />
            <span>Korea Institute of Startup & Entrepreneurship Development</span>
          </Box>
          <Box className="away-point"
            sx={{
              padding: "10px",
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <img
              alt=""
              src="/assets/logo-mss.jpg"
              height="75px"
              style={{ objectFit: "cover" }}
            />
            <span>Ministry of SMEs and Startups</span>
          </Box>
        </Box>

        <div className="video">
          <YoutubeEmbed embedId="HDwt_Bqy4nU" />
        </div>
      </Box>

      {/*<Box
        sx={{
          margin: "10px 12px",
          padding: "20px",
        }}
      >
        <Typography
          variant={"h4"}
          sx={{
            margin: "20px 0",
          }}
          textAlign={"center"}
        >
          Why choose 123Skincare?
        </Typography>
        <Box
          sx={{
            width: "100%",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
            color: brandingColors["grey-font"],
            display: { xs: "none", sm: "flex" },
          }}
        >
          <Box
            sx={{
              padding: "10px 20px",
              width: "50%",
            }}
          >
            <Typography variant={"h5"} textAlign={"left"}>
              Other beauty websites
            </Typography>
          </Box>
          <Box
            sx={{
              padding: "10px 20px",
              width: "50%",
            }}
          >
            <Typography variant={"h5"} textAlign={"left"}>
              123Skincare
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            color: brandingColors["grey-font"],
          }}
        >
          <Box
            sx={{
              padding: "10px 20px",
              width: { xs: "100%", sm: "50%" },
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/thumb_down_alt.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  Confusion
                </Typography>
                <Box sx={{ marginLeft: "29px" }}>
                  <Typography variant={"caption"}>
                    The abundance of available products can be overwhelming. You
                    don't know the best ones to pick-up
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/thumb_down_alt.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  Biased reviews
                </Typography>
                <Box sx={{ marginLeft: "29px" }}>
                  <Typography variant={"caption"}>
                    Sponsored content and biased reviews. It takes a lot of time
                    to figure out which is which.
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/thumb_down_alt.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  Time consuming
                </Typography>
                <Box sx={{ marginLeft: "29px" }}>
                  <Typography variant={"caption"}>
                    {" "}
                    
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              padding: "10px 20px",
              width: { xs: "100%", sm: "50%" },
              borderRadius: "10px",
              background: "white",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "column" },
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/check_circle.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  A platform to ask general queries
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/check_circle.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  Unbiased
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "20px 0",
                }}
              >
                <Typography variant={"subtitle2"}>
                  {" "}
                  <img
                    alt=""
                    src="/assets/check_circle.svg"
                    width="24px"
                    style={{
                      objectFit: "cover",
                      display: "inline",
                      marginRight: "5px",
                    }}
                  />
                  Save time and money
                </Typography>
              </Box>
              <a className="btn" href="#search-box">
              <Button
                variant="contained"
                sx={{
                  color: "white !important",
                  background: "#ff6b73 !important",
                  width: "100%"
                }}
                onClick={() => {
                  fetch("https://www.nyckel.com/connect/token", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: "client_id=womjlujzg6ly9p50tzqplyblvwpdkw20&client_secret=14akjsniydb2rzduiy6enkpxd1op46ej4kx5fkg0c7q8m8tvjvulqocgfc7h3xds&grant_type=client_credentials",
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      try {
                        fetch(
                          "https://www.nyckel.com/v0.9/functions/uqr5ngdavefvkx6l/invoke",
                          {
                            method: "POST",
                            headers: {
                              Authorization: "Bearer " + data.access_token,
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ data: message }),
                          }
                        )
                          .then((response) => response.json())
                          .then((data) => {
                            const tag = _.head(data);
                            const tagLabel = _.get(tag, "labelName");
                            console.log(
                              `/questions?q=${encodeURI(message)}${
                                tagLabel ? `&tag=${tagLabel}` : ""
                              }`
                            );
                            window.location.href =
                              `/questions?q=${encodeURI(message)}${
                                tagLabel ? `&tag=${tagLabel}` : ""
                              }`;
                          });
                      } catch (e) {
                        window.location.href =
                          "/questions?q=" + encodeURI(message);
                      }
                    });
                }}
              >
                Give a try!
              </Button></a>
            </Box>
          </Box>
        </Box>
      </Box>*/}

      {/*<Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "row", md: "row" },
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            padding: { xs: "20px 10px", sm: "20px 20%" },
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              justifyContent: "space-around",
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"h4"} textAlign="center">
                We provide you skincare solution
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "20px 10%",
              }}
            >
              <Typography variant={"subtitle1"} sx={{ color: "#4f6076" }}>
                We're the world first AI-driven beauty recommendation platform.
                We help users find the perfect skincare and beauty products by
                answering their questions and tailoring recommendations to their
                needs.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>*/}

      {/*<Box
        sx={{
          width: "100%",
          display: { xs: "flex", sm: "none" },
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-around",
        }}
      >
        <Carousel
          fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
          swipe={true}
          animation={"slide"}
          duration={1500}
          interval={10000}
        >
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "30%" },
              textAlign: "center",
            }}
          >
            <img
              alt=""
              src="/assets/cc-discover.svg"
              height="75px"
              style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
            />
            <br />
            Skincare beginner
          </Box>
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "30%" },
              textAlign: "center",
            }}
          >
            <img
              alt=""
              src="/assets/sos.svg"
              height="75px"
              style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
            />
            <br />
            Anti-aging sos
          </Box>
          <Box
            sx={{
              padding: "20px",
              borderRadius: "8px",
              background: "white",
              minWidth: "150px",
              maxWidth: { xs: "100%", sm: "250px" },
              width: { xs: "100%", sm: "30%" },
              textAlign: "center",
            }}
          >
            <img
              alt=""
              src="/assets/savings.svg"
              height="75px"
              style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
            />
            <br />
            Savvy consumer
          </Box>
        </Carousel>
      </Box>*/}

      {/*<Box
        sx={{
          width: "100%",
          display: { xs: "none", sm: "flex" },
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-around",
        }}
      >
        <Box
          sx={{
            padding: "20px",
            borderRadius: "8px",
            background: "white",
            minWidth: "150px",
            maxWidth: { xs: "100%", sm: "250px" },
            width: { xs: "100%", sm: "30%" },
            textAlign: "center",
          }}
        >
          <img
            alt=""
            src="/assets/cc-discover.svg"
            height="75px"
            style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
          />
          <br />
          Skincare beginner
        </Box>
        <Box
          sx={{
            padding: "20px",
            borderRadius: "8px",
            background: "white",
            minWidth: "150px",
            maxWidth: { xs: "100%", sm: "250px" },
            width: { xs: "100%", sm: "30%" },
            textAlign: "center",
          }}
        >
          <img
            alt=""
            src="/assets/sos.svg"
            height="75px"
            style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
          />
          <br />
          Anti-aging sos
        </Box>
        <Box
          sx={{
            padding: "20px",
            borderRadius: "8px",
            background: "white",
            minWidth: "150px",
            maxWidth: { xs: "100%", sm: "250px" },
            width: { xs: "100%", sm: "30%" },
            textAlign: "center",
          }}
        >
          <img
            alt=""
            src="/assets/savings.svg"
            height="75px"
            style={{ objectFit: "cover", margin: "0 auto 10px auto" }}
          />
          <br />
          Savvy consumer
        </Box>
      </Box>*/}

      {/* centre */}
      {/*<Box className="footer"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px 0 48px 0",
        }}
      >
        <Box
          sx={{
            padding: "20px",
          }}
        >
          <Typography variant={"h5"}>
            We help users find the perfect skincare and beauty products by
            answering their questions and tailoring recommendations to their
            needs.
          </Typography>
        </Box>*/}

        {/*<Box
          sx={{
            width: "100%",
            display: { xs: "flex", sm: "none" },
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-around",
          }}
        >
          <Carousel
            fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
            swipe={true}
            animation={"slide"}
            duration={1500}
            interval={10000}
          >
            <Box
              sx={{
                padding: { xs: "10px 0px", sm: "10px 20px" },
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                  1000+
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"subtitle1"}>
                  We've helped 1000+ users finding the right skincare products
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: { xs: "10px 0px", sm: "10px 20px" },
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                  35+
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"subtitle1"}>
                  Brands covered by our algorithm
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: { xs: "10px 0px", sm: "10px 20px" },
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                  10+
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"subtitle1"}>
                  Dedicated support from our team of over 10 professionals
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: { xs: "10px 0px", sm: "10px 20px" },
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                  4
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                }}
              >
                <Typography variant={"subtitle1"}>
                  We can help in 4 languages
                </Typography>
              </Box>
            </Box>
          </Carousel>
        </Box>*/}

        {/*<Box
          sx={{
            width: "100%",
            display: { xs: "none", sm: "flex" },
            flexDirection: { xs: "column", md: "column" },
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              padding: { xs: "10px 0px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                1000+
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"subtitle1"}>
                We've helped 1000+ users finding the right skincare products
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: { xs: "10px 0px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                35+
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"subtitle1"}>
                Brands covered by our algorithm
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: { xs: "10px 0px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                10+
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"subtitle1"}>
                Dedicated support from our team of over 10 professionals
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: { xs: "10px 0px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"h3"} sx={{ color: brandingColors.red }}>
                4
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "10px 20px",
              }}
            >
              <Typography variant={"subtitle1"}>
                We can help in 4 languages
              </Typography>
            </Box>
          </Box>
        </Box>*/}

        {/*<Box
          sx={{
            margin: "10px 12px",
            padding: "20px",
            background: "white",
          }}
        >
          <Typography
            variant={"h4"}
            sx={{
              margin: "20px 0",
            }}
          >
            Let's hear what other said...
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: { xs: "none", sm: "flex" },
              flexDirection: { xs: "column", sm: "column" },
              justifyContent: "space-around",
            }}
          >
            <Carousel
              fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
              swipe={true}
              animation={"slide"}
              duration={1500}
              interval={10000}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", md: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "10px 20px",
                    width: { xs: "49%", sm: "49%" },
                    borderRadius: "10px",
                    border: "1px solid #c0c0d6",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "space-around",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"subtitle2"}>
                        Nice service. Discovered new products for my needs.
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"caption"}>Andrea</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    padding: "10px 20px",
                    width: { xs: "49%", sm: "49%" },
                    borderRadius: "10px",
                    border: "1px solid #c0c0d6",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "space-around",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"subtitle2"}>
                        Solved my issue in a few seconds. Thanks!
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"caption"}>Suzy</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: { xs: "row", md: "row" },
                  justifyContent: "space-around",
                }}
              >
                <Box
                  sx={{
                    padding: "10px 20px",
                    width: { xs: "49%", sm: "49%" },
                    borderRadius: "10px",
                    border: "1px solid #c0c0d6",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "space-around",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"subtitle2"}>
                        Helpful service, love how they tailor-made each
                        suggestion!
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"caption"}>Davide</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    padding: "10px 20px",
                    width: { xs: "49%", sm: "49%" },
                    borderRadius: "10px",
                    border: "1px solid #c0c0d6",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", md: "column" },
                      justifyContent: "space-around",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"subtitle2"}>
                        In the future, I will go back to the platform to
                        discover new products. Loved it!
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        padding: "20px 0",
                      }}
                    >
                      <Typography variant={"caption"}>Caterina</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Carousel>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: { xs: "flex", sm: "none" },
              flexDirection: { xs: "column", sm: "column" },
              justifyContent: "space-around",
            }}
          >
            <Carousel
              fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
              swipe={true}
              animation={"slide"}
              duration={1500}
              interval={10000}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                  width: { xs: "100%", sm: "100%" },
                  borderRadius: "10px",
                  border: "1px solid #c0c0d6",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"subtitle2"}>
                      Nice service. Discovered new products for my needs.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"caption"}>Andrea</Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                  width: { xs: "100%", sm: "100%" },
                  borderRadius: "10px",
                  border: "1px solid #c0c0d6",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"subtitle2"}>
                      Solved my issue in a few seconds. Thanks!
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"caption"}>Suzy</Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                  width: { xs: "100%", sm: "100%" },
                  borderRadius: "10px",
                  border: "1px solid #c0c0d6",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"subtitle2"}>
                      Helpful service, love how they tailor-made each
                      suggestion!
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"caption"}>Davide</Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                  width: { xs: "100%", sm: "100%" },
                  borderRadius: "10px",
                  border: "1px solid #c0c0d6",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"subtitle2"}>
                      In the future, I will go back to the platform to discover
                      new products. Loved it!
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"caption"}>Caterina</Typography>
                  </Box>
                </Box>
              </Box>
            </Carousel>
          </Box>
        </Box>
      </Box>*/}
          <FooterComponent />
          </div>
        </div>
      </Box>
    </DocumentMeta>
  );
}
